import { createI18n } from 'vue-i18n'
import { useStorage } from '@vueuse/core'

const messages = {
  pt_BR: {
    message: {
      hello: 'Olá mundo',
      selectLanguage: 'Selecione o Idioma',
      home: 'Início',
      contact: 'Contato',
      faq: 'FAQ',
      help: 'Ajuda',
      terms: 'Termos e Condições',
      privacyPolicy: 'Política de Privacidade',
      portugueseBR: 'Português (BR)',
      portuguesePT: 'Português (PT)',
      english: 'Inglês',
      spanish: 'Espanhol',
      functionalities: 'Funcionalidades',
      solutions: 'Soluções',
      plans: 'Planos',
      login: 'Entrar',
      introTitle:
        'Suas <span style="color: #185c9d;">finanças pessoais</span> e da <span style="color: #185c9d;">empresa</span>, numa <span style="color: #185c9d;">única assinatura</span>.',
      introSubtitle:
        'Chega de planilha espalhada: organize receitas e despesas pessoais e da empresa, num só sistema.',
      createTrialAccount: 'Testar por 30 dias',
      multiBusinessTitle:
        'Gerencie <span style="color: #185c9d;">múltiplos negócios</span> de maneira centralizada',
      multiBusinessDescription:
        'Com o Janela Única Financeiro, você pode centralizar a gestão financeira de todas as suas empresas e negócios em um só lugar, simplificando o controle e otimizando seu tempo.',
      multiBusinessTitle2:
        'Tenha o <span style="color: #185c9d;">controle total</span> e tome decisões baseadas em <span style="color: #185c9d;">dados</span>',
      multiBusinessDescription2:
        'Nossa plataforma oferece uma visão completa e em tempo real das suas finanças, permitindo que você tome decisões mais inteligentes e estratégicas para o futuro do seu negócio.',
      learnMore: 'Saiba Mais',
      centralizeSimplifyTitle:
        '<span style="color: #185c9d;">Simplifique</span> a Sua Gestão de <span style="color: #185c9d;">Negócios</span>',
      centralizeSimplifyDescription:
        'Nossa plataforma é a solução completa para sua empresa, centralizando todas as operações em um único lugar. Desde a emissão de notas fiscais até a gestão financeira, você terá total controle sobre o seu negócio, de forma simples e intuitiva.',
      nfseTitle:
        'Emissão de <span style="color: #185c9d;">NFSe</span> Descomplicada',
      nfseDescription:
        'Esqueça a burocracia. Crie, emita, edite e acompanhe suas <b class="font-weight-bold">Notas Fiscais de Serviço eletrônicas</b> com agilidade. Com a gente, você sincroniza os números, anexa recibos e envia por e-mail de forma automatizada. As faturas dos seus clientes podem ser emitidas com NFSe. Isso garante a conformidade fiscal do seu negócio.',
      financialManagementTitle:
        'Gestão Financeira <span style="color: #185c9d;">Inteligente</span>',
      financialManagementDescription:
        'Tenha uma visão clara da saúde financeira da sua empresa. Gerencie contas, acompanhe movimentações, faça <b class="font-weight-bold">conciliações bancárias</b> e controle centros de custo, tudo para tomar decisões mais estratégicas e informadas. A nossa conciliação automatizada te ajuda a otimizar o seu fluxo de caixa e garantir a previsibilidade financeira do seu negócio.',
      billingSubscriptionsTitle: 'Faturamento e Assinaturas Automatizados',
      billingSubscriptionsDescription:
        'Simplifique seu processo de cobrança. Crie e gerencie assinaturas, emita faturas recorrentes e acompanhe os pagamentos dos seus clientes de perto. Nossos relatórios detalhados te dão uma visão completa do seu faturamento.',
      clientsTitle:
        'Clientes <span style="color: #185c9d;">Fornecedores</span> e <span style="color: #185c9d;">Prestadores de Serviço</span>',
      clientsDescription:
        'Gerencie todos os seus clientes, fornecedores e prestadores de serviços de forma eficiente. Tenha acesso a fichas financeiras, importe listas de contatos e mantenha todas as informações importantes organizadas e fáceis de acessar.',
      reportsDashboardsTitle:
        '<span style="color: #185c9d;">Dashboards</span> e <span style="color: #185c9d;">Relatórios</span> Personalizados',
      reportsDashboardsDescription:
        'Tome decisões baseadas em dados concretos. Nossos dashboards intuitivos e relatórios personalizáveis oferecem uma visão 360º do seu negócio, permitindo que você visualize gráficos financeiros, acompanhe o desempenho e exporte dados para análises mais aprofundadas.',
      plansIntro:
        'O Janela Única Financeiro oferece planos que atendem a diversos perfis de prestadores de serviço, seja <b>MEI</b>, <b>Micro e Pequena Empresa</b>, ou até mesmo <b>Pessoas Físicas</b>.',
      by: 'Por',
      monthlyInvestment: 'investimento mensal*',
      subscribeNow: 'Assine já',
      contactUs: 'Entre em contato',
      onDemandPlan: 'Plano sob demanda',
      planBasic: 'Basic',
      basicFeature1: '2GB de Armazenamento',
      basicFeature2: 'Até 2 Organizações',
      basicFeature3: 'Até 2 Contas financeiras por Organização',
      basicFeature4: 'Até 2 Usuários por Organização',
      basicFeature5: 'Emissão de até 10 notas fiscais de serviço mensal',
      basicFeature6: 'Envio de até 2 lotes com 500 e-mails para seus clientes mensal',
      basicFeature7: '1 caixa de e-mail',
      basicDescription:
        'Ideal para quem precisa gerenciar as finanças de um <b>negócio</b> e as próprias finanças <b>pessoais</b>. Você pode ter acesso para <b>poucos usuários</b> e gerenciar suas movimentações em <b>contas financeiras</b> distintas. É ótimo para quem emite <b>poucas notas fiscais</b> de serviço por mês.',
      planStandard: 'Standard',
      standardFeature1: '4GB de Armazenamento',
      standardFeature2: 'Até 4 Organizações',
      standardFeature3: 'Até 4 Usuários por Organização',
      standardFeature4: 'Até 4 Contas financeiras por Organização',
      standardFeature5: 'Emissão de até 50 notas fiscais de serviço mensal',
      standardFeature6:
        'Envio de até 5 lotes com 500 e-mails para seus clientes mensal',
      standardFeature7: 'Até 2 caixas de e-mail',
      standardDescription:
        'Perfeito para quem tem <b>poucos negócios</b> e precisa de um controle financeiro mais robusto. Permite <b>mais usuários</b> e a gestão de suas movimentações em diversas <b>contas financeiras</b>. Inclui a emissão de <b>mais notas fiscais</b> e a capacidade de <b>enviar lotes de e-mail</b> para seus clientes.',
      planPremium: 'Premium',
      premiumFeature1: '10GB de Armazenamento',
      premiumFeature2: 'Até 10 Organizações',
      premiumFeature3: 'Até 10 Usuários por Organização',
      premiumFeature4: 'Contas financeiras ilimitadas por Organização',
      premiumFeature5: 'Emissão de até 100 notas fiscais de serviço mensal',
      premiumFeature6:
        'Envio de até 10 lotes com 500 e-mails para seus clientes mensal',
      premiumFeature7: 'Até 4 caixas de e-mail',
      premiumDescription:
        'Feito para quem possui <b>vários negócios</b> e necessita de um gerenciamento financeiro <b>completo e ilimitado</b>. Você pode ter <b>muitos usuários</b> administrando suas contas e gerenciar movimentações em <b>contas financeiras ilimitadas</b>. É ideal para quem emite um <b>grande volume de notas fiscais</b> e envia <b>lotes de e-mail</b> com frequência.',
      explanation:
        '<b>Organizações</b> são perfis com movimentações financeiras próprias. Cada <b>usuário</b> tem suas credenciais e permissões no sistema. O <b>armazenamento</b> total do plano inclui 1GB por organização. <b>Contas financeiras</b> referem-se a carteiras, caixas, instituições financeiras, etc.',
      fixedValueDisclaimer: '*Valor fixo e sem fidelidade.',
      referentialValueDisclaimer:
        '**Valor meramente referencial. Não há planos intermediários.',
      footer: {
        aboutUs:
          'O Janela Única Financeiro é um sistema voltado a prestadores de serviço e pessoas físicas que têm a necessidade de gerenciamento de contas empresariais e pessoais em uma única plataforma.',
        contact: 'Contato',
        socialNetworks: 'Redes Sociais',
        company: 'Empresa',
        juFinanceiro: 'JU Financeiro',
        apps: 'Aplicativos',
        copyright:
          '2022. Maia Produção de Softwares Ltda - Todos os direitos reservados',
      },
      videoNfseTitle: 'Facilite sua vida <br> e a do seu contador',
      videoNfseText: 'Emissão simplificada de <strong>NFSe</strong>',
      videoFinancasTitle: 'Controle avançado de <b>Receitas e Despesas</b>',
      videoFinancasText: 'Tenha controle total',
      videoConciliacaoTitle: 'Conciliação bancária <br> <b>automatizada</b>',
      videoConciliacaoText:
        'Economize tempo e garanta o <strong>controle</strong>',
      videoFaturasTitle: 'Fature seus clientes <br> com facilidade',
      videoFaturasText:
        'Emita Faturas e Recibos <strong>personalizados</strong>',
      videoListItem1: 'Contas a Pagar e Receber',
      videoListItem2: 'Faturas e Recibos',
      videoListItem3: 'Conciliação bancária',
      videoListItem4: 'Receitas e Despesas',
      videoListItem5: 'Relatórios e Dashboards',
      videoListItem6: 'Administração de Contas',
      videoListItem7: 'Emissão de NFSe',
      videoListItem8: 'Exportação de Dados',
      videoListItem9: 'Multi Moedas',
      contactTitle: 'Entre em Contato',
      contactSubtitle:
        'Estamos aqui para ajudar. Fale conosco pelo canal que preferir.',
      contactWhatsapp: 'WhatsApp',
      contactWhatsappText: 'Converse conosco agora mesmo! (Clique aqui)',
      contactInstagram: 'Instagram',
      contactFacebook: 'Facebook',
      contactAddress: 'Endereço',
      contactAddressInfo: 'Travessa Barão do Triunfo, 3540A - Marco',
      contactAddressInfo2: 'Belém - PA, sala: 813, CEP: 66095-055, Brasil',
      contactEmail: 'E-mails',
      contactPhone: 'Telefones',
      topBar: {
        excellence: 'Excelência em tecnologia da informação',
        transforming: 'Transformando dados em decisões',
        experience: 'Experiência comprovada',
      },
      since1999: 'Desde 1999 inovando em soluções digitais',
      faqTitle: 'Perguntas Frequentes',
      faqDescription:
        'Encontre as respostas das principais dúvidas relacionadas ao JU Financeiro',
      eventBanner: {
        message:
          'Estaremos como expositores no <a href="https://ntwsummit.com/" target="_blank" style="color: #64a5e6; text-decoration: underline;">NTW Summit 2025</a>!  <br>Em comemoração, estamos oferecendo <span style="color: #64a5e6;">50% de desconto</span>!',
        expiresIn: 'Expira em:',
        close: 'Fechar',
        linksButton: 'Acessar links',
        greeting:
          'Saudações aos participantes do NTW Summit 2025! Estamos felizes em fazer parte deste grande evento.',
      },
      copyButton: {
        copy: 'Copiar',
        copied: 'Copiado!',
      },
      appComingSoon: {
        eyebrow: 'Novidade',
        title:
          'O app do<br /><span style="color: #185c9d;">JU&nbsp;Financeiro</span><br />já chegou',
        description:
          'Baixe agora o aplicativo oficial para iOS e Android e gerencie suas finanças pessoais e da sua empresa de qualquer lugar, direto do celular.',
        soon: 'Baixar agora',
      },
    },
    sections: {
      features: {
        title: 'Principais Funcionalidades',
        subtitle:
          'Organize suas contas a receber, mantenha em dia as suas contas a pagar, tome decisões com segurança em sua empresa, entre outras soluções, com um único sistema e assinatura!',
        items: {
          nfse: {
            title: 'Emissão de <span style="color: #185c9d;">NFS-e</span>',
            shortDescription:
              'Otimize seu processo de faturamento com nossa emissão de NFS-e integrada e simplificada.',
            longDescription:
              'Agilize a emissão de Notas Fiscais de Serviço (NFS-e) e garanta a conformidade fiscal do seu negócio. Nossa plataforma permite clonar notas com um clique, automatizando o faturamento e integrando todas as informações financeiras em um só lugar.',
          },
          reports: {
            title: 'Relatórios e <span style="color: #185c9d;">Gráficos</span>',
            shortDescription:
              'Tome decisões estratégicas com base em relatórios e gráficos financeiros precisos e em tempo real.',
            longDescription:
              'Transforme dados brutos em insights valiosos. Com nossos relatórios e gráficos dinâmicos, você obtém uma visão clara da saúde financeira da sua empresa, permitindo decisões mais rápidas e seguras para impulsionar o crescimento.',
          },
          transactions: {
            title:
              'Movimentações <span style="color: #185c9d;">Financeiras</span>',
            shortDescription:
              'Monitore o fluxo de caixa e tenha controle total sobre as movimentações financeiras da sua empresa.',
            longDescription:
              'Gerencie todas as transações financeiras com precisão. Acompanhe entradas, saídas, transferências e saldos em tempo real para manter um fluxo de caixa saudável e garantir a previsibilidade financeira do seu negócio.',
          },
          accounts: {
            title:
              'Contas a Pagar e <span style="color: #185c9d;">Receber</span>',
            shortDescription:
              'Automatize a gestão de contas a pagar e receber, garantindo a pontualidade e a saúde financeira.',
            longDescription:
              'Simplifique a gestão de suas obrigações financeiras. Controle suas contas a pagar e a receber de forma eficiente, evite multas por atraso e tenha uma visão clara das suas projeções de recebimento para otimizar o capital de giro.',
          },
          multicurrency: {
            title:
              'Lançamentos <span style="color: #185c9d;">Multimoedas</span>',
            shortDescription:
              'Expanda seus negócios globalmente com suporte a contas e transações em múltiplas moedas.',
            longDescription:
              'Prepare sua empresa para o mercado internacional. Oferecemos suporte completo para contas financeiras e transações em diversas moedas, ideal para negócios que atuam com clientes e fornecedores no exterior.',
          },
          contracts: {
            title: 'Gestão de <span style="color: #185c9d;">Contratos</span>',
            shortDescription:
              'Centralize a gestão de contratos, do faturamento à renovação, de forma automatizada.',
            longDescription:
              'Otimize o ciclo de vida dos seus contratos. Nossa plataforma permite um controle completo, desde a criação e negociação até o faturamento recorrente e a gestão de renovações, garantindo eficiência e minimizando riscos.',
          },
          emails: {
            title: 'Lotes de <span style="color: #185c9d;">E-mails</span>',
            shortDescription:
              'Comunique-se de forma eficaz com seus clientes através do envio de e-mails em lote.',
            longDescription:
              'Fortaleça o relacionamento com seus clientes. Envie comunicações, faturas e notificações em lote, utilizando contatos salvos no sistema ou importados, e personalize suas mensagens para campanhas mais eficientes.',
          },
          statements: {
            title:
              'Importação de <span style="color: #185c9d;">Extratos</span>',
            shortDescription:
              'Simplifique a conciliação bancária com a importação automática de extratos em formato OFX,CSV, XSLX e outros.',
            longDescription:
              'Reduza o tempo gasto com tarefas manuais. Importe extratos bancários (OFX) de forma rápida e segura para automatizar a conciliação, garantindo a precisão dos seus registros financeiros e otimizando sua rotina.',
          },
        },
      },
      tagCloud: {
        title: 'Explore um Universo de Funcionalidades',
        description:
          'Navegue por nossa nuvem de tags e descubra a vasta gama de recursos que o nosso sistema oferece. Cada tag representa uma funcionalidade pensada para otimizar a sua gestão financeira, desde o controle de despesas até a emissão de notas fiscais.',
        tags: {
          expenseControl: 'Controle de Despesas',
          nfseIssuance: 'Emissão de NFSe',
          contractManagement: 'Gestão de Contratos',
          managementReports: 'Relatórios Gerenciais',
          accountsPayable: 'Contas a Pagar',
          accountsReceivable: 'Contas a Receber',
          bankReconciliation: 'Conciliação Bancária',
          multiBusiness: 'Multi-Empresas',
          multiCurrency: 'Multi-Moedas',
          financialDashboard: 'Dashboard Financeiro',
          statementImport: 'Importação de Extratos',
          invoiceDispatch: 'Envio de Faturas',
          budgetPlanning: 'Importação de Faturas',
          billingAutomation: 'Gestão de Contatos',
          inventoryControl: 'Integração com Google Agenda',
          customerManagement: 'Gestão de Clientes',
          costCenter: 'Centro de Custos',
          dataSecurity: 'Segurança de Dados',
          accessLogs: 'Logs de Acesso',
          onlineSupport: 'Suporte Online',
          customization: 'Personalização',
          dynamicCharts: 'Gráficos Dinâmicos',
        },
      },
    },
    faq: {
      'what-is-ju-financeiro': 'O que é o JU Financeiro?',
      'what-is-trial-period': 'Como funciona o período de teste gratuito?',
      'how-to-subscribe': 'Como faço para assinar o JU Financeiro?',
      'payment-method': 'Quais formas de pagamento são aceitas?',
      'cancel-subscription': 'Como cancelar minha assinatura?',
      'forgot-password': 'Esqueci minha senha, e agora?',
      'data-security': 'Meus dados estão seguros?',
      'credit-card-storage':
        'Os dados do meu cartão de crédito são armazenados?',
      'multiple-organizations':
        'Posso gerenciar várias empresas com uma única assinatura?',
      'what-is-financial-organization':
        'O que são as organizações financeiras?',
      'trial-features':
        'Tenho acesso a todas as funcionalidades durante o período de teste?',
    },
  },
  pt_PT: {
    message: {
      hello: 'Olá mundo',
      selectLanguage: 'Selecione o idioma',
      home: 'Início',
      contact: 'Contacto',
      faq: 'FAQ',
      help: 'Ajuda',
      terms: 'Termos e Condições',
      privacyPolicy: 'Política de Privacidade',
      portugueseBR: 'Português (BR)',
      portuguesePT: 'Português (PT)',
      english: 'Inglês',
      spanish: 'Espanhol',
      functionalities: 'Funcionalidades',
      solutions: 'Soluções',
      plans: 'Planos',
      login: 'Entrar',
      introTitle:
        'As suas <span style="color: #185c9d;">finanças pessoais</span> e da <span style="color: #185c9d;">empresa</span>, numa <span style="color: #185c9d;">única assinatura</span>.',
      introSubtitle:
        'Chega de folhas de cálculo espalhadas: organize receitas e despesas pessoais e da empresa, num só sistema.',
      createTrialAccount: 'Testar por 30 dias',
      multiBusinessTitle:
        'Faça a gestão de <span style="color: #185c9d;">múltiplos negócios</span> de maneira centralizada',
      multiBusinessDescription:
        'Com o Janela Única Financeiro, pode centralizar a gestão financeira de todas as suas empresas e negócios num só lugar, simplificando o controlo e otimizando o seu tempo.',
      multiBusinessTitle2:
        'Tenha o <span style="color: #185c9d;">controlo total</span> e tome decisões baseadas em <span style="color: #185c9d;">dados</span>',
      multiBusinessDescription2:
        'A nossa plataforma oferece uma visão completa e em tempo real das suas finanças, permitindo tomar decisões mais inteligentes e estratégicas para o futuro do seu negócio.',
      learnMore: 'Saiba Mais',
      centralizeSimplifyTitle:
        '<span style="color: #185c9d;">Simplifique</span> a Sua Gestão de <span style="color: #185c9d;">Negócios</span>',
      centralizeSimplifyDescription:
        'A nossa plataforma é a solução completa para a sua empresa, centralizando todas as operações num único lugar. Desde a emissão de notas fiscais até à gestão financeira, terá o controlo total sobre o seu negócio, de forma simples e intuitiva.',
      nfseTitle:
        'Emissão de <span style="color: #185c9d;">NFSe</span> Descomplicada',
      nfseDescription:
        'Esqueça a burocracia. Crie, emita, edite e acompanhe as suas <b class="font-weight-bold">Notas Fiscais de Serviço eletrónicas</b> com agilidade. Sincronize os números, anexe recibos e envie por e-mail de forma automatizada. As faturas dos seus clientes podem ser emitidas com NFSe. Isto garante a conformidade fiscal do seu negócio.',
      financialManagementTitle:
        'Gestão Financeira <span style="color: #185c9d;">Inteligente</span>',
      financialManagementDescription:
        'Tenha uma visão clara da saúde financeira da sua empresa. Faça a gestão de contas, acompanhe movimentações, faça <b class="font-weight-bold">conciliações bancárias</b> e controle centros de custo, tudo para tomar decisões mais estratégicas e informadas.',
      billingSubscriptionsTitle: 'Faturação e Assinaturas Automatizadas',
      billingSubscriptionsDescription:
        'Simplifique o seu processo de cobrança. Crie e faça a gestão de assinaturas, emita faturas recorrentes e acompanhe de perto os pagamentos dos seus clientes. Os nossos relatórios detalhados dão-lhe uma visão completa da sua faturação.',
      clientsTitle:
        'Clientes <span style="color: #185c9d;">Fornecedores</span> e <span style="color: #185c9d;">Prestadores de Serviço</span>',
      clientsDescription:
        'Faça a gestão de todos os seus clientes, fornecedores e prestadores de serviços de forma eficiente. Tenha acesso a fichas financeiras, importe listas de contactos e mantenha todas as informações importantes organizadas e de fácil acesso.',
      reportsDashboardsTitle:
        '<span style="color: #185c9d;">Dashboards</span> e <span style="color: #185c9d;">Relatórios</span> Personalizados',
      reportsDashboardsDescription:
        'Tome decisões baseadas em dados concretos. Os nossos dashboards intuitivos e relatórios personalizáveis oferecem uma visão a 360º do seu negócio, permitindo visualizar gráficos financeiros, acompanhar o desempenho e exportar dados para análises mais aprofundadas.',
      plansIntro:
        'O Janela Única Financeiro oferece planos que atendem a diversos perfis de prestadores de serviço, seja <b>MEI</b>, <b>Micro e Pequena Empresa</b>, ou até mesmo <b>Pessoas Singulares</b>.',
      by: 'Por',
      monthlyInvestment: 'investimento mensal*',
      subscribeNow: 'Assine já',
      contactUs: 'Entre em contacto',
      onDemandPlan: 'Plano sob consulta',
      planBasic: 'Basic',
      basicFeature1: '2GB de Armazenamento',
      basicFeature2: 'Até 2 Organizações',
      basicFeature3: 'Até 2 Contas financeiras por Organização',
      basicFeature4: 'Até 2 Utilizadores por Organização',
      basicFeature5: 'Emissão de até 10 notas fiscais de serviço mensal',
      basicFeature6: 'Envio de até 2 lotes com 500 e-mails para os seus clientes, mensalmente',
      basicFeature7: '1 caixa de e-mail',
      basicDescription:
        'Ideal para quem precisa de gerir as finanças de um <b>negócio</b> e as próprias finanças <b>pessoais</b>. Pode ter acesso para <b>poucos utilizadores</b> e gerir as suas movimentações em <b>contas financeiras</b> distintas. É ótimo para quem emite <b>poucas notas fiscais</b> de serviço por mês.',
      planStandard: 'Standard',
      standardFeature1: '4GB de Armazenamento',
      standardFeature2: 'Até 4 Organizações',
      standardFeature3: 'Até 4 Utilizadores por Organização',
      standardFeature4: 'Até 4 Contas financeiras por Organização',
      standardFeature5: 'Emissão de até 50 notas fiscais de serviço mensal',
      standardFeature6:
        'Envio de até 5 lotes com 500 e-mails para os seus clientes, mensalmente',
      standardFeature7: 'Até 2 caixas de e-mail',
      standardDescription:
        'Perfeito para quem tem <b>poucos negócios</b> e precisa de um controlo financeiro mais robusto. Permite <b>mais utilizadores</b> e a gestão das suas movimentações em diversas <b>contas financeiras</b>. Inclui a emissão de <b>mais notas fiscais</b> e a capacidade de <b>enviar lotes de e-mail</b> aos seus clientes.',
      planPremium: 'Premium',
      premiumFeature1: '10GB de Armazenamento',
      premiumFeature2: 'Até 10 Organizações',
      premiumFeature3: 'Até 10 Utilizadores por Organização',
      premiumFeature4: 'Contas financeiras ilimitadas por Organização',
      premiumFeature5: 'Emissão de até 100 notas fiscais de serviço mensal',
      premiumFeature6:
        'Envio de até 10 lotes com 500 e-mails para os seus clientes, mensalmente',
      premiumFeature7: 'Até 4 caixas de e-mail',
      premiumDescription:
        'Feito para quem possui <b>vários negócios</b> e necessita de uma gestão financeira <b>completa e ilimitada</b>. Pode ter <b>muitos utilizadores</b> a administrar as suas contas e a gerir movimentações em <b>contas financeiras ilimitadas</b>. É ideal para quem emite um <b>grande volume de notas fiscais</b> e envia <b>lotes de e-mail</b> com frequência.',
      explanation:
        '<b>Organizações</b> são perfis com movimentações financeiras próprias. Cada <b>utilizador</b> tem as suas credenciais e permissões no sistema. O <b>armazenamento</b> total do plano inclui 1GB por organização. <b>Contas financeiras</b> referem-se a carteiras, caixas, instituições financeiras, etc.',
      fixedValueDisclaimer: '*Valor fixo e sem fidelidade.',
      referentialValueDisclaimer:
        '**Valor meramente referencial. Não há planos intermediários.',
      footer: {
        aboutUs:
          'O Janela Única Financeiro é um sistema voltado para prestadores de serviços e pessoas singulares que têm a necessidade de gestão de contas empresariais e pessoais numa única plataforma.',
        contact: 'Contacto',
        socialNetworks: 'Redes Sociais',
        company: 'Empresa',
        juFinanceiro: 'JU Financeiro',
        apps: 'Aplicações',
        copyright:
          '2022. Maia Produção de Softwares Ltda - Todos os direitos reservados',
      },
      videoNfseTitle: 'Facilite a sua vida <br> e a do seu contabilista',
      videoNfseText: 'Emissão simplificada de <strong>NFSe</strong>',
      videoFinancasTitle: 'Controlo avançado de <b>Receitas e Despesas</b>',
      videoFinancasText: 'Tenha controlo total',
      videoConciliacaoTitle: 'Conciliação bancária <br> <b>automatizada</b>',
      videoConciliacaoText:
        'Poupe tempo e garanta o <strong>controlo</strong>',
      videoFaturasTitle: 'Fature os seus clientes <br> com facilidade',
      videoFaturasText:
        'Emita Faturas e Recibos <strong>personalizados</strong>',
      videoListItem1: 'Contas a Pagar e Receber',
      videoListItem2: 'Faturas e Recibos',
      videoListItem3: 'Conciliação bancária',
      videoListItem4: 'Receitas e Despesas',
      videoListItem5: 'Relatórios e Dashboards',
      videoListItem6: 'Administração de Contas',
      videoListItem7: 'Emissão de NFSe',
      videoListItem8: 'Exportação de Dados',
      videoListItem9: 'Multi Moedas',
      contactTitle: 'Entre em Contacto',
      contactSubtitle:
        'Estamos aqui para ajudar. Fale connosco através do canal que preferir.',
      contactWhatsapp: 'WhatsApp',
      contactWhatsappText: 'Converse connosco agora mesmo! (Clique aqui)',
      contactInstagram: 'Instagram',
      contactFacebook: 'Facebook',
      contactAddress: 'Endereço',
      contactAddressInfo: 'Travessa Barão do Triunfo, 3540A - Marco',
      contactAddressInfo2: 'Belém - PA, sala: 813, CEP: 66095-055, Brasil',
      contactEmail: 'E-mails',
      contactPhone: 'Telefones',
      topBar: {
        excellence: 'Excelência em tecnologia da informação',
        transforming: 'Transformando dados em decisões',
        experience: 'Experiência comprovada',
      },
      since1999: 'Desde 1999 inovando em soluções digitais',
      faqTitle: 'Perguntas Frequentes',
      faqDescription:
        'Encontre as respostas das principais dúvidas relacionadas ao JU Financeiro',
      eventBanner: {
        message:
          'Estaremos como expositores no <a href="https://ntwsummit.com/" target="_blank" style="color: #64a5e6; text-decoration: underline;">NTW Summit 2025</a> <br>! Em comemoração, estamos a oferecer <span style="color: #64a5e6;">50% de desconto</span>!',

        expiresIn: 'Expira em:',
        close: 'Fechar',
        linksButton: 'Aceder aos links',
        greeting:
          'Saudações aos participantes do NTW Summit 2025! Estamos felizes por fazer parte deste grande evento.',
      },
      copyButton: {
        copy: 'Copiar',
        copied: 'Copiado!',
      },
      appComingSoon: {
        eyebrow: 'Novidade',
        title:
          'A aplicação do<br /><span style="color: #185c9d;">JU&nbsp;Financeiro</span><br />já chegou',
        description:
          'Descarregue já a aplicação oficial para iOS e Android e gira as suas finanças pessoais e da sua empresa a partir de qualquer lugar, diretamente do telemóvel.',
        soon: 'Descarregar',
      },
    },
    sections: {
      features: {
        title: 'Principais Funcionalidades',
        subtitle:
          'Organize as suas contas a receber, mantenha em dia as suas contas a pagar, tome decisões com segurança na sua empresa, entre outras soluções, com um único sistema e assinatura!',
        items: {
          nfse: {
            title: 'Emissão de <span style="color: #185c9d;">NFS-e</span>',
            shortDescription:
              'Otimize o seu processo de faturação com a nossa emissão de NFS-e integrada e simplificada.',
            longDescription:
              'Agilize a emissão de Notas Fiscais de Serviço (NFS-e) e garanta a conformidade fiscal do seu negócio. A nossa plataforma permite clonar notas com um clique, automatizando a faturação e integrando todas as informações financeiras num só lugar.',
          },
          reports: {
            title: 'Relatórios e <span style="color: #185c9d;">Gráficos</span>',
            shortDescription:
              'Tome decisões estratégicas com base em relatórios e gráficos financeiros precisos e em tempo real.',
            longDescription:
              'Transforme dados brutos em insights valiosos. Com os nossos relatórios e gráficos dinâmicos, obtém uma visão clara da saúde financeira da sua empresa, permitindo decisões mais rápidas e seguras para impulsionar o crescimento.',
          },
          transactions: {
            title:
              'Movimentações <span style="color: #185c9d;">Financeiras</span>',
            shortDescription:
              'Monitorize o fluxo de caixa e tenha controlo total sobre as movimentações financeiras da sua empresa.',
            longDescription:
              'Faça a gestão de todas as transações financeiras com precisão. Acompanhe entradas, saídas, transferências e saldos em tempo real para manter um fluxo de caixa saudável e garantir a previsibilidade financeira do seu negócio.',
          },
          accounts: {
            title:
              'Contas a Pagar e <span style="color: #185c9d;">Receber</span>',
            shortDescription:
              'Automatize a gestão de contas a pagar e a receber, garantindo a pontualidade e a saúde financeira.',
            longDescription:
              'Simplifique a gestão das suas obrigações financeiras. Controle as suas contas a pagar e a receber de forma eficiente, evite multas por atraso e tenha uma visão clara das suas projeções de recebimento para otimizar o fundo de maneio.',
          },
          multicurrency: {
            title:
              'Lançamentos <span style="color: #185c9d;">Multimoedas</span>',
            shortDescription:
              'Expanda os seus negócios globalmente com suporte a contas e transações em múltiplas moedas.',
            longDescription:
              'Prepare a sua empresa para o mercado internacional. Oferecemos suporte completo para contas financeiras e transações em diversas moedas, ideal para negócios que atuam com clientes e fornecedores no exterior.',
          },
          contracts: {
            title: 'Gestão de <span style="color: #185c9d;">Contratos</span>',
            shortDescription:
              'Centralize a gestão de contratos, da faturação à renovação, de forma automatizada.',
            longDescription:
              'Otimize o ciclo de vida dos seus contratos. A nossa plataforma permite um controlo completo, desde a criação e negociação até à faturação recorrente e a gestão de renovações, garantindo eficiência e minimizando riscos.',
          },
          emails: {
            title: 'Lotes de <span style="color: #185c9d;">E-mails</span>',
            shortDescription:
              'Comunique-se de forma eficaz com os seus clientes através do envio de e-mails em lote.',
            longDescription:
              'Fortaleça o relacionamento com os seus clientes. Envie comunicações, faturas e notificações em lote, utilizando contactos guardados no sistema ou importados, e personalize as suas mensagens para campanhas mais eficientes.',
          },
          statements: {
            title:
              'Importação de <span style="color: #185c9d;">Extratos</span>',
            shortDescription:
              'Simplifique a conciliação bancária com a importação automática de extratos em formato OFX,CSV, XSLX e outros.',
            longDescription:
              'Reduza o tempo gasto com tarefas manuais. Importe extratos bancários (OFX) de forma rápida e segura para automatizar a conciliação, garantindo a precisão dos seus registos financeiros e otimizando a sua rotina.',
          },
        },
      },
      tagCloud: {
        title: 'Explore um Universo de Funcionalidades',
        description:
          'Navegue pela nossa nuvem de tags e descubra a vasta gama de recursos que o nosso sistema oferece. Cada tag representa uma funcionalidade pensada para otimizar a sua gestão financeira, desde o controlo de despesas até à emissão de notas fiscais.',
        tags: {
          expenseControl: 'Controlo de Despesas',
          nfseIssuance: 'Emissão de NFSe',
          contractManagement: 'Gestão de Contratos',
          managementReports: 'Relatórios de Gestão',
          accountsPayable: 'Contas a Pagar',
          accountsReceivable: 'Contas a Receber',
          bankReconciliation: 'Conciliação Bancária',
          multiBusiness: 'Multi-Empresas',
          multiCurrency: 'Multi-Moedas',
          financialDashboard: 'Dashboard Financeiro',
          statementImport: 'Importação de Extratos',
          invoiceDispatch: 'Envio de Faturas',
          costCenter: 'Centro de Custos',
          customerManagement: 'Gestão de Clientes',
          budgetPlanning: 'Importação de Faturas',
          billingAutomation: 'Gestão de Contactos',
          inventoryControl: 'Integração com Google Agenda',
          dataSecurity: 'Segurança de Dados',
          accessLogs: 'Logs de Acesso',
          onlineSupport: 'Suporte Online',
          customization: 'Personalização',
          dynamicCharts: 'Gráficos Dinâmicos',
        },
      },
    },
    faq: {
      'what-is-ju-financeiro': 'O que é o JU Financeiro?',
      'what-is-trial-period': 'Como funciona o período de teste gratuito?',
      'how-to-subscribe': 'Como faço para assinar o JU Financeiro?',
      'payment-method': 'Quais são as formas de pagamento aceites?',
      'cancel-subscription': 'Como cancelar a minha assinatura?',
      'forgot-password': 'Esqueci-me da minha palavra-passe, e agora?',
      'data-security': 'Os meus dados estão seguros?',
      'credit-card-storage':
        'Os dados do meu cartão de crédito são guardados?',
      'multiple-organizations':
        'Posso gerir várias empresas com uma única assinatura?',
      'what-is-financial-organization':
        'O que são as organizações financeiras?',
      'trial-features':
        'Tenho acesso a todas as funcionalidades durante o período de teste?',
    },
  },
  en: {
    message: {
      hello: 'Hello world',
      selectLanguage: 'Select Language',
      home: 'Home',
      contact: 'Contact',
      faq: 'FAQ',
      help: 'Help',
      terms: 'Terms and Conditions',
      privacyPolicy: 'Privacy Policy',
      portugueseBR: 'Portuguese (BR)',
      portuguesePT: 'Portuguese (PT)',
      english: 'English',
      spanish: 'Spanish',
      functionalities: 'Functionalities',
      solutions: 'Solutions',
      plans: 'Plans',
      login: 'Login',
      introTitle:
        'Your <span style="color: #185c9d;">personal finances</span> and your <span style="color: #185c9d;">business</span>, in one <span style="color: #185c9d;">single subscription</span>.',
      introSubtitle:
        'No more scattered spreadsheets: organize personal and business income and expenses in one single system.',
      createTrialAccount: 'Try for 30 days',
      multiBusinessTitle:
        'Manage <span style="color: #185c9d;">multiple businesses</span> in a centralized way',
      multiBusinessDescription:
        'With Janela Única Financeiro, you can centralize the financial management of all your companies and businesses in one place, simplifying control and optimizing your time.',
      multiBusinessTitle2:
        'Have <span style="color: #185c9d;">total control</span> and make decisions based on <span style="color: #185c9d;">data</span>',
      multiBusinessDescription2:
        'Our platform offers a complete, real-time view of your finances, allowing you to make smarter, more strategic decisions for your business future.',
      learnMore: 'Learn More',
      centralizeSimplifyTitle:
        '<span style="color: #185c9d;">Simplify</span> Your <span style="color: #185c9d;">Business</span> Management',
      centralizeSimplifyDescription:
        'Our platform is the complete solution for your company, centralizing all operations in one place. From issuing invoices to financial management, you will have total control over your business, simply and intuitively.',
      nfseTitle:
        'Simplified <span style="color: #185c9d;">NFSe</span> Issuance',
      nfseDescription:
        'Forget bureaucracy. Create, issue, edit, and track your electronic Service Invoices with agility. With us, you synchronize numbers, attach receipts, and send them by email automatically.',
      financialManagementTitle:
        'Smart <span style="color: #185c9d;">Financial</span> Management',
      financialManagementDescription:
        "Get a clear view of your company's financial health. Manage accounts, track transactions, perform bank reconciliations and control cost centers, all to make more strategic and informed decisions.",
      billingSubscriptionsTitle: 'Automated Billing and Subscriptions',
      billingSubscriptionsDescription:
        "Simplify your billing process. Create and manage subscriptions, issue recurring invoices and track your customers' payments closely. Our detailed reports give you a complete overview of your billing.",
      clientsTitle:
        'Clients <span style="color: #185c9d;">Suppliers</span> and <span style="color: #185c9d;">Service Providers</span>',
      clientsDescription:
        'Manage all your contacts, partners and contracts efficiently. Have access to financial records, import contact lists and keep all important information organized and easy to access.',
      reportsDashboardsTitle:
        '<span style="color: #185c9d;">Custom Dashboards</span> and <span style="color: #185c9d;">Reports</span>',
      reportsDashboardsDescription:
        'Make decisions based on concrete data. Our intuitive dashboards and customizable reports offer a 360º view of your business, allowing you to view financial charts, track performance, and export data for deeper analysis.',
      plansIntro:
        'Janela Única Financeiro offers plans that cater to various service provider profiles, whether <b>MEI</b>, <b>Micro and Small Business</b>, or even <b>Individuals</b>.',
      by: 'By',
      monthlyInvestment: 'monthly investment*',
      subscribeNow: 'Subscribe Now',
      contactUs: 'Contact us',
      onDemandPlan: 'On-demand plan',
      planBasic: 'Basic',
      basicFeature1: '2GB Storage',
      basicFeature2: 'Up to 2 Organizations',
      basicFeature3: 'Up to 2 Financial Accounts per Organization',
      basicFeature4: 'Up to 2 Users per Organization',
      basicFeature5: 'Issuance of up to 10 monthly service invoices',
      basicFeature6: 'Sending up to 2 batches of 500 emails to your clients monthly',
      basicFeature7: '1 email inbox',
      basicDescription:
        "Ideal for those who need to manage the finances of <b>one business</b> and their own <b>personal finances</b>. You can have access for <b>a few users</b> and manage your transactions in <b>distinct financial accounts</b>. It's great for those who issue <b>a few service invoices</b> per month.",
      planStandard: 'Standard',
      standardFeature1: '4GB Storage',
      standardFeature2: 'Up to 4 Organizations',
      standardFeature3: 'Up to 4 Users per Organization',
      standardFeature4: 'Up to 4 Financial Accounts per Organization',
      standardFeature5: 'Issuance of up to 50 monthly service invoices',
      standardFeature6:
        'Sending up to 5 batches of 500 emails to your clients monthly',
      standardFeature7: 'Up to 2 email inboxes',
      standardDescription:
        'Perfect for those with <b>a few businesses</b> and needing more robust financial control. It allows for <b>more users</b> and the management of your transactions across various <b>financial accounts</b>. It includes the issuance of <b>more service invoices</b> and the ability to <b>send email batches</b> to your clients.',
      planPremium: 'Premium',
      premiumFeature1: '10GB Storage',
      premiumFeature2: 'Up to 10 Organizations',
      premiumFeature3: 'Up to 10 Users per Organization',
      premiumFeature4: 'Unlimited Financial Accounts per Organization',
      premiumFeature5: 'Issuance of up to 100 monthly service invoices',
      premiumFeature6:
        'Sending up to 10 batches of 500 emails to your clients monthly',
      premiumFeature7: 'Up to 4 email inboxes',
      premiumDescription:
        "Tailored for those with <b>multiple businesses</b> who require <b>complete and unlimited</b> financial management. You can have <b>many users</b> managing their accounts and handle transactions in <b>unlimited financial accounts</b>. It's ideal for those who issue a <b>large volume of service invoices</b> and frequently <b>send email batches</b>.",
      explanation:
        '<b>Organizations</b> are profiles with their own financial transactions. Each <b>user</b> has their own credentials and system usage permissions. The total <b>storage</b> of the plan includes 1GB per organization. <b>Financial accounts</b> refer to wallets, cash, financial institutions, etc.',
      fixedValueDisclaimer: '*Fixed value and no loyalty.',
      referentialValueDisclaimer:
        '**Referential value. There are no intermediate plans.',
      footer: {
        aboutUs:
          'Janela Única Financeiro is a system aimed at service providers and individuals who need to manage business and personal accounts on a single platform.',
        contact: 'Contact',
        socialNetworks: 'Social Networks',
        company: 'Company',
        juFinanceiro: 'JU Financeiro',
        apps: 'Apps',
        copyright:
          '2022. Maia Produção de Softwares Ltda - All rights reserved',
      },
      videoNfseTitle: 'Make your life <br> easier',
      videoNfseText: 'Simplified <strong>NFSe</strong> Issuance',
      videoFinancasTitle: 'Advanced control of <b>Income and Expenses</b>',
      videoFinancasText: 'Have total control',
      videoConciliacaoTitle: '<b>Automated</b> bank<br> reconciliation',
      videoConciliacaoText: 'Save time and ensure <strong>control</strong>',
      videoFaturasTitle: 'Invoice your customers <br> with ease',
      videoFaturasText:
        'Issue <strong>customized</strong> Invoices and Receipts',
      videoListItem1: 'Acc. Payable and Receivable',
      videoListItem2: 'Invoices and Receipts',
      videoListItem3: 'Bank reconciliation',
      videoListItem4: 'Income and Expenses',
      videoListItem5: 'Reports and Dashboards',
      videoListItem6: 'Account Management',
      videoListItem7: 'NFSe Issuance',
      videoListItem8: 'Data Export',
      videoListItem9: 'Multi-Currency',
      contactTitle: 'Get in Touch',
      contactSubtitle:
        'We are here to help. Talk to us through your preferred channel.',
      contactWhatsapp: 'WhatsApp',
      contactWhatsappText: 'Chat with us right now! (Click here)',
      contactInstagram: 'Instagram',
      contactFacebook: 'Facebook',
      contactAddress: 'Address',
      contactAddressInfo: 'Travessa Barão do Triunfo, 3540A - Marco',
      contactAddressInfo2: 'Belém - PA, room: 813, ZIP: 66095-055, Brazil',
      contactEmail: 'E-mails',
      contactPhone: 'Phones',
      topBar: {
        excellence: 'Excellence in information technology',
        transforming: 'Transforming data into decisions',
        experience: 'Proven experience',
      },
      since1999: 'Innovating in digital solutions since 1999',
      faqTitle: 'Frequently Asked Questions',
      faqDescription:
        'Find the answers to the main questions related to JU Financeiro',
      eventBanner: {
        message:
          'We will be exhibitors at the <a href="https://ntwsummit.com/" target="_blank" style="color: #64a5e6; text-decoration: underline;">NTW Summit 2025</a>! <br> In celebration, we are offering a <span style="color: #64a5e6;">50% discount</span>!',

        expiresIn: 'Expires in:',
        close: 'Close',
        linksButton: 'Access links',
        greeting:
          'Greetings to the attendees of NTW Summit 2025! We are happy to be part of this great event.',
      },
      copyButton: {
        copy: 'Copy',
        copied: 'Copied!',
      },
      appComingSoon: {
        eyebrow: 'New',
        title:
          'The<br /><span style="color: #185c9d;">JU&nbsp;Financeiro</span><br />app is here',
        description:
          'Download the official app for iOS and Android now and manage your personal and business finances from anywhere, right from your phone.',
        soon: 'Download now',
      },
    },
    sections: {
      features: {
        title: 'Main Features',
        subtitle:
          'Organize your accounts receivable, keep your accounts payable up to date, make decisions with security in your company, among other solutions, with a single system and subscription!',
        items: {
          nfse: {
            title: 'Issuance of <span style="color: #185c9d;">NFS-e</span>',
            shortDescription:
              'Optimize your billing process with our integrated and simplified NFS-e issuance.',
            longDescription:
              'Streamline the issuance of Service Invoices (NFS-e) and ensure your business fiscal compliance. Our platform allows you to clone notes with a click, automating billing and integrating all financial information in one place.',
          },
          reports: {
            title: 'Reports and <span style="color: #185c9d;">Charts</span>',
            shortDescription:
              'Make strategic decisions based on accurate and real-time financial reports and charts.',
            longDescription:
              'Turn raw data into valuable insights. With our dynamic reports and charts, you get a clear view of your company financial health, allowing for faster and safer decisions to boost growth.',
          },
          transactions: {
            title:
              'Financial <span style="color: #185c9d;">Transactions</span>',
            shortDescription:
              'Monitor cash flow and have full control over your company financial transactions.',
            longDescription:
              'Manage all financial transactions with precision. Track income, expenses, transfers, and balances in real time to maintain a healthy cash flow and ensure your business financial predictability.',
          },
          accounts: {
            title:
              'Accounts Payable and <span style="color: #185c9d;">Receivable</span>',
            shortDescription:
              'Automate the management of accounts payable and receivable, ensuring punctuality and financial health.',
            longDescription:
              'Simplify the management of your financial obligations. Control your accounts payable and receivable efficiently, avoid late fees, and have a clear view of your receiving projections to optimize working capital.',
          },
          multicurrency: {
            title:
              'Multicurrency <span style="color: #185c9d;">Transactions</span>',
            shortDescription:
              'Expand your business globally with support for accounts and transactions in multiple currencies.',
            longDescription:
              'Prepare your company for the international market. We offer full support for financial accounts and transactions in several currencies, ideal for businesses that deal with customers and suppliers abroad.',
          },
          contracts: {
            title: 'Contract <span style="color: #185c9d;">Management</span>',
            shortDescription:
              'Centralize contract management, from billing to renewal, in an automated way.',
            longDescription:
              'Optimize the life cycle of your contracts. Our platform allows for complete control, from creation and negotiation to recurring billing and renewal management, ensuring efficiency and minimizing risks.',
          },
          emails: {
            title: 'Email <span style="color: #185c9d;">Batches</span>',
            shortDescription:
              'Communicate effectively with your customers by sending bulk emails.',
            longDescription:
              'Strengthen the relationship with your customers. Send communications, invoices, and notifications in batches, using contacts saved in the system or imported, and customize your messages for more efficient campaigns.',
          },
          statements: {
            title: 'Statement <span style="color: #185c9d;">Import</span>',
            shortDescription:
              'Simplify bank reconciliation with automatic import of statements in OFX, CSV, XLSX and other formats.',
            longDescription:
              'Reduce the time spent on manual tasks. Import bank statements (OFX) quickly and safely to automate reconciliation, ensuring the accuracy of your financial records and optimizing your routine.',
          },
        },
      },
      tagCloud: {
        title: 'Explore a Universe of Functionalities',
        description:
          'Browse our tag cloud and discover the wide range of features our system offers. Each tag represents a functionality designed to optimize your financial management, from expense control to issuing invoices.',
        tags: {
          expenseControl: 'Expense Control',
          nfseIssuance: 'NFSe Issuance',
          contractManagement: 'Contract Management',
          managementReports: 'Management Reports',
          accountsPayable: 'Accounts Payable',
          accountsReceivable: 'Accounts Receivable',
          bankReconciliation: 'Bank Reconciliation',
          multiBusiness: 'Multi-Business',
          multiCurrency: 'Multi-Currency',
          financialDashboard: 'Financial Dashboard',
          statementImport: 'Statement Import',
          invoiceDispatch: 'Invoice Dispatch',
          billingAutomation: 'Billing Automation',
          budgetPlanning: 'Budget Planning',
          costCenter: 'Cost Center',
          customerManagement: 'Customer Management',
          inventoryControl: 'Inventory Control',
          dataSecurity: 'Data Security',
          accessLogs: 'Access Logs',
          onlineSupport: 'Online Support',
          customization: 'Customization',
          dynamicCharts: 'Dynamic Charts',
        },
      },
    },
    faq: {
      'what-is-ju-financeiro': 'What is JU Financeiro?',
      'what-is-trial-period': 'How does the free trial period work?',
      'how-to-subscribe': 'How do I subscribe to JU Financeiro?',
      'payment-method': 'What payment methods are accepted?',
      'cancel-subscription': 'How do I cancel my subscription?',
      'forgot-password': 'I forgot my password, what now?',
      'data-security': 'Is my data secure?',
      'credit-card-storage': 'Is my credit card data stored?',
      'multiple-organizations':
        'Can I manage multiple companies with a single subscription?',
      'what-is-financial-organization': 'What are financial organizations?',
      'trial-features':
        'Do I have access to all features during the trial period?',
    },
  },
  es: {
    message: {
      hello: 'Hola mundo',
      selectLanguage: 'Seleccionar Idioma',
      home: 'Inicio',
      contact: 'Contacto',
      faq: 'Preguntas Frecuentes',
      help: 'Ayuda',
      terms: 'Términos y Condiciones',
      privacyPolicy: 'Política de Privacidad',
      portugueseBR: 'Portugués (BR)',
      portuguesePT: 'Portugués (PT)',
      english: 'Inglés',
      spanish: 'Español',
      functionalities: 'Funcionalidades',
      solutions: 'Soluciones',
      plans: 'Planes',
      login: 'Iniciar Sesión',
      introTitle:
        'Tus <span style="color: #185c9d;">finanzas personales</span> y de tu <span style="color: #185c9d;">empresa</span>, en una <span style="color: #185c9d;">única suscripción</span>.',
      introSubtitle:
        'Basta de hojas de cálculo dispersas: organiza tus ingresos y gastos personales y de tu empresa en un solo sistema.',
      createTrialAccount: 'Prueba gratis por 30 días',
      multiBusinessTitle:
        'Gestiona <span style="color: #185c9d;">múltiples negocios</span> de forma centralizada',
      multiBusinessDescription:
        'Con Janela Única Financeiro, puedes centralizar la gestión financiera de todas tus empresas y negocios en un solo lugar, simplificando el control y optimizando tu tiempo.',
      multiBusinessTitle2:
        'Ten el <span style="color: #185c9d;">control total</span> y tome decisiones basadas en <span style="color: #185c9d;">datos</span>',
      multiBusinessDescription2:
        'Nuestra plataforma ofrece una visión completa y en tiempo real de tus finanzas, permitiéndote tomar decisiones más inteligentes y estratégicas para el futuro de tu negocio.',
      learnMore: 'Saber Más',
      centralizeSimplifyTitle:
        '<span style="color: #185c9d;">Simplifica</span> la Gestión de tu <span style="color: #185c9d;">Negocio</span>',
      centralizeSimplifyDescription:
        'Nuestra plataforma es la solución completa para tu empresa, centralizando todas las operaciones en un único lugar. Desde la emisión de facturas hasta la gestión financiera, tendrás control total sobre tu negocio, de forma sencilla e intuitiva.',
      nfseTitle:
        'Emisión de <span style="color: #185c9d;">NFSe</span> Simplificada',
      nfseDescription:
        'Olvídate de la burocracia. Crea, emite, edita y realiza un seguimiento de tus Facturas de Servicio electrónicas con agilidad. Con nosotros, sincronizas los números, adjunta recibos y los envías por correo electrónico de forma automatizada.',
      financialManagementTitle:
        'Gestión Financiera <span style="color: #185c9d;">Inteligente</span>',
      financialManagementDescription:
        'Ten una visión clara de la salud financiera de tu empresa. Administra cuentas, realiza un seguimiento de los movimientos, realiza conciliaciones bancarias y controla los centros de costo, todo para tomar decisiones más estratégicas e informadas.',
      billingSubscriptionsTitle: 'Facturación y Suscripciones Automatizadas',
      billingSubscriptionsDescription:
        'Simplifica tu proceso de cobranza. Crea y gestiona suscripciones, emite facturas recurrentes y sigue de cerca los pagos de tus clientes. Nuestros informes detallados te dan una visión completa de tu facturación.',
      clientsTitle:
        'Clientes, <span style="color: #185c9d;">Proveedores</span> y <span style="color: #185c9d;">Prestadores de Servicios</span>',
      clientsDescription:
        'Gestiona todos tus contactos, socios y contratos de forma eficiente. Ten acceso a fichas financieras, importa listas de contactos y mantén toda la información importante organizada y fácil de acceder.',
      reportsDashboardsTitle:
        '<span style="color: #185c9d;">Dashboards</span> y <span style="color: #185c9d;">Informes</span> Personalizados',
      reportsDashboardsDescription:
        'Toma decisiones basadas en datos concretos. Nuestros paneles intuitivos e informes personalizables ofrecen una visión de 360º de tu negocio, permitiéndote ver gráficos financieros, realizar un seguimiento del rendimiento y exportar datos para análisis más profundos.',
      plansIntro:
        'Janela Única Financeiro ofrece planes que se adaptan a diversos perfiles de proveedores de servicios, ya sean <b>MEI</b>, <b>Micro y Pequeñas Empresas</b>, o incluso <b>Personas Físicas</b>.',
      by: 'Por',
      monthlyInvestment: 'inversión mensual*',
      subscribeNow: 'Suscribirse ahora',
      contactUs: 'Contáctenos',
      onDemandPlan: 'Plan bajo demanda',
      planBasic: 'Básico',
      basicFeature1: '2GB de Almacenamiento',
      basicFeature2: 'Hasta 2 Organizaciones',
      basicFeature3: 'Hasta 2 Cuentas financieras por Organización',
      basicFeature4: 'Hasta 2 Usuarios por Organización',
      basicFeature5: 'Emisión de hasta 10 facturas de servicio mensuales',
      basicFeature6: 'Envío de hasta 2 lotes con 500 correos electrónicos a sus clientes mensualmente',
      basicFeature7: '1 buzón de correo electrónico',
      basicDescription:
        'Ideal para quienes necesitan gestionar las finanzas de <b>un negocio</b> y sus propias finanzas <b>personales</b>. Puede tener acceso para <b>pocos usuarios</b> y gestionar sus transacciones en <b>cuentas financieras</b> distintas. Es excelente para quienes emiten <b>pocas facturas</b> de servicio al mes.',
      planStandard: 'Estándar',
      standardFeature1: '4GB de Almacenamiento',
      standardFeature2: 'Hasta 4 Organizaciones',
      standardFeature3: 'Hasta 4 Usuarios por Organización',
      standardFeature4: 'Hasta 4 Cuentas financieras por Organización',
      standardFeature5: 'Emisión de hasta 50 facturas de servicio mensuales',
      standardFeature6:
        'Envío de hasta 5 lotes con 500 correos electrónicos a sus clientes mensualmente',
      standardFeature7: 'Hasta 2 buzones de correo electrónico',
      standardDescription:
        'Perfecto para quienes tienen <b>pocos negocios</b> y necesitan un control financiero más robusto. Permite <b>más usuarios</b> y la gestión de sus transacciones en diversas <b>cuentas financieras</b>. Incluye la emisión de <b>más facturas</b> y la capacidad de <b>enviar lotes de correo electrónico</b> a sus clientes.',
      planPremium: 'Premium',
      premiumFeature1: '10GB de Almacenamiento',
      premiumFeature2: 'Hasta 10 Organizaciones',
      premiumFeature3: 'Hasta 10 Usuarios por Organización',
      premiumFeature4: 'Cuentas financieras ilimitadas por Organización',
      premiumFeature5: 'Emisión de hasta 100 facturas de servicio mensuales',
      premiumFeature6:
        'Envío de hasta 10 lotes con 500 correos electrónicos a sus clientes mensualmente',
      premiumFeature7: 'Hasta 4 buzones de correo electrónico',
      premiumDescription:
        'Hecho a medida para quienes tienen <b>múltiples negocios</b> y requieren una gestión financiera <b>completa e ilimitada</b>. Puede tener <b>muchos usuarios</b> administrando sus cuentas y manejar transacciones en <b>cuentas financieras ilimitadas</b>. Es ideal para quienes emiten un <b>gran volumen de facturas</b> y envía <b>lotes de correo electrónico</b> con frecuencia.',
      explanation:
        '<b>Organizaciones</b> son perfiles con sus propias transacciones financieras. Cada <b>usuario</b> tiene sus propias credenciales y permisos de uso dentro del sistema. El <b>almacenamiento</b> total del plan incluye 1 GB por organización. Las <b>cuentas financieras</b> se refieren a carteras, efectivo, instituciones financieras, etc.',
      fixedValueDisclaimer: '*Valor fijo y sin fidelidad.',
      referentialValueDisclaimer:
        '**Valor meramente referencial. No hay planes intermedios.',
      footer: {
        aboutUs:
          'Janela Única Financeiro es un sistema dirigido a proveedores de servicios y particulares que necesitan gestionar cuentas empresariales y personales en una única plataforma.',
        contact: 'Contacto',
        socialNetworks: 'Redes Sociales',
        company: 'Empresa',
        juFinanceiro: 'JU Financeiro',
        apps: 'Aplicaciones',
        copyright:
          '2022. Maia Produção de Softwares Ltda - Todos los derechos reservados',
      },
      videoNfseTitle: 'Facilita tu vida <br> y la de tu contador',
      videoNfseText: 'Emisión simplificada de <strong>NFSe</strong>',
      videoFinancasTitle: 'Control avanzado de <b>Ingresos y Gastos</b>',
      videoFinancasText: 'Ten control total',
      videoConciliacaoTitle: 'Conciliación bancaria <br> <b>automatizada</b>',
      videoConciliacaoText:
        'Ahorra tiempo y garantiza el <strong>control</strong>',
      videoFaturasTitle: 'Factura a tus clientes <br> con facilidad',
      videoFaturasText:
        'Emite Facturas y Recibos <strong>personalizados</strong>',
      videoListItem1: 'Cuentas por Pagar y Cobrar',
      videoListItem2: 'Facturas y Recibos',
      videoListItem3: 'Conciliación bancaria',
      videoListItem4: 'Ingresos y Gastos',
      videoListItem5: 'Informes y Dashboards',
      videoListItem6: 'Administración de Cuentas',
      videoListItem7: 'Emisión de NFSe',
      videoListItem8: 'Exportación de Datos',
      videoListItem9: 'Multi Monedas',
      contactTitle: 'Póngase en contacto',
      contactSubtitle:
        'Estamos aquí para ayudar. Hable con nosotros a través de su canal preferido.',
      contactWhatsapp: 'WhatsApp',
      contactWhatsappText: '¡Chatea con nosotros ahora mismo! (Haga clic aquí)',
      contactInstagram: 'Instagram',
      contactFacebook: 'Facebook',
      contactAddress: 'Dirección',
      contactAddressInfo: 'Travessa Barão do Triunfo, 3540A - Marco',
      contactAddressInfo2: 'Belém - PA, sala: 813, CEP: 66095-055, Brasil',
      contactEmail: 'E-mails',
      contactPhone: 'Teléfonos',
      topBar: {
        excellence: 'Excelencia en tecnología de la información',
        transforming: 'Transformando datos en decisiones',
        experience: 'Experiencia comprobada',
      },
      since1999: 'Innovando en soluciones digitales desde 1999',
      faqTitle: 'Preguntas Frecuentes',
      faqDescription:
        'Encuentre las respuestas a las principales dudas relacionadas con JU Financeiro',
      eventBanner: {
        message:
          '¡Estaremos como expositores en el <a href="https://ntwsummit.com/" target="_blank" style="color: #64a5e6; text-decoration: underline;">NTW Summit 2025</a>! <br> ¡En celebración, estamos ofreciendo un <span style="color: #64a5e6;">50% de descuento</span>!',

        expiresIn: 'Expira en:',
        close: 'Cerrar',
        linksButton: 'Acceder a los enlaces',
        greeting:
          '¡Saludos a los asistentes al NTW Summit 2025! Estamos felices de ser parte de este gran evento.',
      },
      copyButton: {
        copy: 'Copiar',
        copied: '¡Copiado!',
      },
      appComingSoon: {
        eyebrow: 'Novedad',
        title:
          'La app de<br /><span style="color: #185c9d;">JU&nbsp;Financeiro</span><br />ya está aquí',
        description:
          'Descarga ya la aplicación oficial para iOS y Android y gestiona tus finanzas personales y las de tu empresa desde cualquier lugar, directamente desde el celular.',
        soon: 'Descargar ahora',
      },
    },
    sections: {
      features: {
        title: 'Principais Funcionalidades',
        subtitle:
          'Organiza tus cuentas por cobrar, mantén tus cuentas por pagar al día, toma decisiones con seguridad en tu empresa, entre otras soluciones, con un único sistema y suscripción!',
        items: {
          nfse: {
            title: 'Emisión de <span style="color: #185c9d;">NFS-e</span>',
            shortDescription:
              'Optimiza tu proceso de facturación con nuestra emisión de NFS-e integrada y simplificada.',
            longDescription:
              'Agiliza la emisión de Facturas de Servicio (NFS-e) y garantiza el cumplimiento fiscal de tu negocio. Nuestra plataforma te permite clonar facturas con un clic, automatizando la facturación e integrando toda la información financiera en un solo lugar.',
          },
          reports: {
            title: 'Informes y <span style="color: #185c9d;">Gráficos</span>',
            shortDescription:
              'Toma decisiones estratégicas basadas en informes y gráficos financieros precisos y en tiempo real.',
            longDescription:
              'Convierte datos brutos en información valiosa. Con nuestros informes y gráficos dinámicos, obtienes una visión clara de la salud financiera de tu empresa, lo que permite tomar decisiones más rápidas y seguras para impulsar el crecimiento.',
          },
          transactions: {
            title:
              'Movimientos <span style="color: #185c9d;">Financieros</span>',
            shortDescription:
              'Monitorea el flujo de caja y ten control total sobre los movimientos financieros de tu empresa.',
            longDescription:
              'Gestiona todas las transacciones financieras con precisión. Realiza un seguimiento de los ingresos, gastos, transferencias y saldos en tiempo real para mantener un flujo de caja saludable y garantizar la previsibilidad financiera de tu negocio.',
          },
          accounts: {
            title:
              'Cuentas por Pagar y <span style="color: #185c9d;">Cobrar</span>',
            shortDescription:
              'Automatiza la gestión de cuentas por pagar y cobrar, garantizando la puntualidad y la salud financiera.',
            longDescription:
              'Simplifica la gestión de tus obligaciones financieras. Controla tus cuentas por pagar y cobrar de manera eficiente, evita multas por demora y ten una visión clara de tus proyecciones de cobro para optimizar el capital de trabajo.',
          },
          multicurrency: {
            title:
              'Lanzamientos <span style="color: #185c9d;">Multimoneda</span>',
            shortDescription:
              'Expande tus negocios a nivel mundial con soporte para cuentas y transacciones en múltiples monedas.',
            longDescription:
              'Prepara tu empresa para el mercado internacional. Ofrecemos soporte completo para cuentas financieras y transacciones en varias monedas, ideal para empresas que tratan con clientes y proveedores en el extranjero.',
          },
          contracts: {
            title: 'Gestión de <span style="color: #185c9d;">Contratos</span>',
            shortDescription:
              'Centraliza la gestión de contratos, desde la facturación hasta la renovación, de forma automatizada.',
            longDescription:
              'Optimiza el ciclo de vida de tus contratos. Nuestra plataforma permite un control total, desde la creación y negociación hasta la facturación recurrente y la gestión de renovaciones, garantizando la eficiencia y minimizando los riesgos.',
          },
          emails: {
            title:
              'Lotes de <span style="color: #185c9d;">Correos Electrónicos</span>',
            shortDescription:
              'Comunícate de manera efectiva con tus clientes mediante el envío de correos electrónicos masivos.',
            longDescription:
              'Fortalece la relación con tus clientes. Envía comunicaciones, facturas y notificaciones por lotes, utilizando contactos guardados en el sistema o importados, y personaliza tus mensajes para campañas más eficientes.',
          },
          statements: {
            title:
              'Importación de <span style="color: #185c9d;">Extractos</span>',
            shortDescription:
              'Simplifica la conciliación bancaria con la importación automática de extractos en formato OFX, CSV, XLSX y otros.',
            longDescription:
              'Reduce el tiempo dedicado a tareas manuales. Importa extractos bancarios (OFX) de forma rápida y segura para automatizar la conciliación, garantizando la precisión de tus registros financieros y optimizando tu rutina.',
          },
        },
      },
      tagCloud: {
        title: 'Explora un Universo de Funcionalidades',
        description:
          'Navega por nuestra nube de etiquetas y descubre la amplia gama de características que ofrece nuestro sistema. Cada etiqueta representa una funcionalidad diseñada para optimizar tu gestión financiera, desde el control de gastos hasta la emisión de facturas.',
        tags: {
          expenseControl: 'Control de Gastos',
          nfseIssuance: 'Emisión de NFSe',
          contractManagement: 'Gestión de Contratos',
          managementReports: 'Informes de Gestión',
          accountsPayable: 'Cuentas por Pagar',
          accountsReceivable: 'Cuentas por Cobrar',
          bankReconciliation: 'Conciliación Bancaria',
          multiBusiness: 'Multi-Empresas',
          multiCurrency: 'Multi-Moneda',
          financialDashboard: 'Dashboard Financiero',
          statementImport: 'Importación de Extractos',
          invoiceDispatch: 'Envío de Facturas',
          costCenter: 'Centro de Costos',
          customerManagement: 'Gestión de Clientes',
          budgetPlanning: 'Importación de facturas',
          billingAutomation: 'Gestión de contactos',
          inventoryControl: 'Integración con Google Calendar',
          dataSecurity: 'Seguridad de Datos',
          accessLogs: 'Registros de Acceso',
          onlineSupport: 'Soporte en Línea',
          customization: 'Personalización',
          dynamicCharts: 'Gráficos Dinâmicos',
        },
      },
    },
    faq: {
      'what-is-ju-financeiro': '¿Qué es JU Financeiro?',
      'what-is-trial-period': '¿Cómo funciona el período de prueba gratuito?',
      'how-to-subscribe': '¿Cómo me suscribo a JU Financeiro?',
      'payment-method': '¿Qué métodos de pago se aceptan?',
      'cancel-subscription': '¿Cómo cancelo mi suscripción?',
      'forgot-password': 'Olvidé mi contraseña, ¿y ahora qué?',
      'data-security': '¿Están seguros mis datos?',
      'credit-card-storage':
        '¿Se almacenan los datos de mi tarjeta de crédito?',
      'multiple-organizations':
        '¿Puedo gestionar varias empresas con una sola suscripción?',
      'what-is-financial-organization':
        '¿Qué son las organizaciones financieras?',
      'trial-features':
        '¿Tengo acceso a todas las funciones durante el período de prueba?',
    },
  },
}

const language = useStorage('language', 'pt_BR')
const languageManuallySelected = useStorage('language_manually_selected', false)

const i18n = createI18n({
  legacy: false,
  locale: language.value,
  fallbackLocale: 'en',
  messages: messages,
  escapeParameter: false,
})

const CACHE_KEY_LOCATION = 'user_location'
const CACHE_KEY_TTL = 'user_location_ttl'
const CACHE_TTL_MS = 1000 * 60 * 60 * 12 // 12 hours

const userLocation = useStorage(CACHE_KEY_LOCATION, null)
const userLocationTTL = useStorage(CACHE_KEY_TTL, null)

const spanishSpeakingCountries = [
  'AR',
  'BO',
  'CL',
  'CO',
  'CR',
  'CU',
  'DO',
  'EC',
  'SV',
  'GQ',
  'GT',
  'HN',
  'MX',
  'NI',
  'PA',
  'PY',
  'PE',
  'ES',
  'UY',
  'VE',
  'PR',
]

const portugueseSpeakingCountries = [
  'BR',
  'PT',
  'AO',
  'MZ',
  'CV',
  'GW',
  'ST',
  'TL',
]

async function setLocaleByLocation() {
  const now = Date.now()

  if (
    userLocation.value &&
    userLocationTTL.value &&
    now < userLocationTTL.value
  ) {
    const country = userLocation.value
    if (portugueseSpeakingCountries.includes(country)) {
      language.value = 'pt_BR'
    } else if (spanishSpeakingCountries.includes(country)) {
      language.value = 'es'
    } else {
      language.value = 'en'
    }
    i18n.global.locale.value = language.value
    return
  }

  try {
    const response = await fetch('https://ipinfo.io/json?token=b9ec19d5af638e')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    const country = data.country

    userLocation.value = country
    userLocationTTL.value = now + CACHE_TTL_MS

    if (portugueseSpeakingCountries.includes(country)) {
      language.value = 'pt_BR'
    } else if (spanishSpeakingCountries.includes(country)) {
      language.value = 'es'
    } else {
      language.value = 'en'
    }
    i18n.global.locale.value = language.value
  } catch (error) {
    console.error('Error detecting user location:', error)
  }
}

if (typeof window !== 'undefined') {
  if (!languageManuallySelected.value) {
    setLocaleByLocation()
  }
}

export default i18n
export { language, languageManuallySelected }
